export default __webpack_public_path__ + "static/media/tidal-bw.a0e12e80.svg";